// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__15PSG","approved":"Status_approved__1sPJD","rejected":"Status_rejected__1h61Y","expired":"Status_expired__y13Fp","label":"Status_label__2mXpY"};